import { FlowListItem } from '../types/Flow';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { INamedItem, ITypedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export type GetFlowsParams = IGetItemsParams;

export type GetFlowsResult = IGetItemsResult & {
  flows?: FlowListItem[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  favorites?: string[];
  maxStats?: IUsageInfo;
};

export class GetFlowsRequest extends Request<GetFlowsParams, GetFlowsResult> {
  constructor(params: GetFlowsParams) {
    super('getFlows', params);
  }
}
